module.exports = __webpack_public_path__ + "static/media/privacy_policy.9d3e15a1.svg";